const NotificationsLayout = () => import('@/pages/notifications/NotificationsLayout.vue')
const NotificationsPage = () => import('@/pages/notifications/NotificationsPage.vue')
const NotificationsArchive = () => import('@/pages/notifications/NotificationsArchive.vue')
const NotificationsCalendar = () => import('@/pages/notifications/NotificationsCalendar.vue')
const ChatPage = () => import('@/pages/notifications/ChatPage.vue')
const ChatMessagesPage = () => import('@/pages/notifications/ChatMessagesPage.vue')

export default [
  {
    path: 'notifications',
    name: 'notifications',
    component: NotificationsLayout,
    meta: {
      layout: 'default',
      requiresAuth: true,
      background: 'secondary'
    },
    children: [
      {
        path: '',
        name: 'NotificationsPage',
        component: NotificationsPage,
        meta: {
          layout: 'default',
          requiresAuth: true
        }
      },
      {
        path: 'archive',
        name: 'NotificationsArchive',
        component: NotificationsArchive,
        meta: {
          layout: 'default',
          requiresAuth: true
        }
      },
      {
        path: 'calendar',
        name: 'NotificationsCalendar',
        component: NotificationsCalendar,
        meta: {
          layout: 'default',
          requiresAuth: true
        }
      },
      {
        path: 'chat',
        name: 'ChatPage',
        component: ChatPage,
        meta: {
          layout: 'default',
          requiresAuth: true,
          background: 'secondary'
        },
        children: [
          {
            path: ':slug',
            name: 'ChatMessagesPage',
            component: ChatMessagesPage
          }
        ]
      }
    ]
  }
]
